module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAgCAYAAADjaQM7AAAAvElEQVRIie3XP4oCMRQH4G8G2X6tFKy32it4ianXRvAIXsBSr6A2W8+7hIex0yNooYgM/seARX6QJgnvC0mTV9R1/YUZ/tD2/mzxj3ELU/zgF+tnK1VVdXM9IrpYYlJigOEr0IOHWR/rj0qHq0sCNcB2mRJpJmMZy1jGMpaxjGXsBWyFXXNExCoFdi3FoxtbTxTtX5q890k9z8e+2VuwDbopkYjoYFM6dBhzdBJBPSwwL85apgG+E3inlmkP208qF5SSjxIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/login/zhang.png
// module id = W+w8
// module chunks = 1